import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state:{
        //存放的键值对就是所要管理的状态
        telephoneCount: 0,  //当前弹屏数量
        telephoneReserve:[],// 电话弹屏传入的数据
        popCustomerData:[],//电话弹屏客户信息和服务信息数据
        workOrderCount: 0,  //当前工单详情数量
        workOrderReserve:[],// 工单传入的数据
        popWorkOrderData:[],//工单里的信息
        thirdPopupAddressList: [], //三方弹屏地址,
        onlineData: [],
        globalMqClient:null,  //全局mq对象，这里遇到的问题是，签入时连接的对象，发送消息无法获取。解决方法：在这里管理一个client对象，在线客服发送消息从这里取client对象
        globalUnreadMsgCnt: {"cnt":0},  //未读消息数量，必须是对象才能实现实时刷新
        globalNoticeMsgList:[],
    },
    mutations:{
        addWorkOrderReserve(state,reserve){
          let pageUuId = reserve[reserve.length-1].pageUuId;
          reserve = reserve.slice(0,-1);
          let index = state.workOrderReserve.findIndex(item => item.pageUuId === pageUuId);
          if(index > -1){  //说明已经有了,先删除，保证数据最新
            state.workOrderCount--;
            state.workOrderReserve.splice(index,1);
          }
          state.workOrderCount++;
          let param = {
            objData:JSON.parse(JSON.stringify(reserve)),
            pageUuId:pageUuId,
          }
          let newParam = JSON.parse(JSON.stringify(param));
          state.workOrderReserve.push(newParam);
        },
        addReserve(state,reserve){
            let index = state.telephoneReserve.findIndex(item => item.phoneUUid === reserve.phoneUUid);
            if(index > -1){  //说明已经有了,先删除，保证数据最新
                state.telephoneCount--;
                state.telephoneReserve.splice(index,1);
            }
            state.telephoneCount++;
            state.telephoneReserve.push(reserve);
        },
        addWorkOrderData(state,customerData){
          let index = state.popWorkOrderData.findIndex(item => item.pageUuId === customerData.pageUuId);
          if(index > -1){  //说明已经有了,先删除，保证数据最新
            state.popWorkOrderData.splice(index,1);
          }
          let newCustomerData = JSON.parse(JSON.stringify(customerData));
          state.popWorkOrderData.push(newCustomerData);
        },
        addCustomerData(state,customerData){
            let index = state.popCustomerData.findIndex(item => item.telephone === customerData.telephone);
            if(index > -1){  //说明已经有了,先删除，保证数据最新
                state.popCustomerData.splice(index,1);
            }
            // 增加一个唯一标识
            customerData["phoneUUid"] = "pop_"+customerData.telephone;
            state.popCustomerData.push(customerData);
        },
        addAIData(state,customerData){
          let indexOne = state.popCustomerData.findIndex(item => item.telephone === customerData.telephone);
          let newAiContent = state.popCustomerData[indexOne].screenAiContent;
          if (newAiContent.length < 1) {
            newAiContent.push(customerData.aiParam);
            return;
          }
          let index = customerData.aiParam.index;
          let direction = customerData.aiParam.direction;
          for (let i = newAiContent.length - 1; i >= 0; i--) {
            if (newAiContent[i].index == index && newAiContent[i].direction == direction) {
              state.popCustomerData[indexOne].screenAiContent[i] = customerData.aiParam;
              return;
            }
            if (newAiContent[i].index == (index - 1) && newAiContent[i].direction == direction) {
              break;
            }
          }
          newAiContent.push(customerData.aiParam);
          state.popCustomerData[indexOne].screenAiContent = newAiContent;
        },
        delWorkOrderData(state,pageUuId){
          let index = state.workOrderReserve.findIndex(item => item.pageUuId === pageUuId);
          if(index > -1){
            state.workOrderReserve.splice(index,1);
          }

          index = state.popWorkOrderData.findIndex(item => item.pageUuId === pageUuId);
          if(index > -1){
            state.popWorkOrderData.splice(index,1);
            state.workOrderCount--;
          }

          
        },
        delTelephoneData(state,phoneUUid){
            let index = state.telephoneReserve.findIndex(item => item.phoneUUid === phoneUUid);
            if(index > -1){
                state.telephoneReserve.splice(index,1);
            }

            index = state.popCustomerData.findIndex(item => item.phoneUUid === phoneUUid);
            if(index > -1){
                state.popCustomerData.splice(index,1);
                state.telephoneCount--;
            }

            
        },
        //清空工单数据
        clearWorkOrderData(state){
          state.workOrderReserve=[];
          state.popWorkOrderData = [];
          state.workOrderCount = 0;
        },
        //更新工单指定数据
        updateWorkOrderData(state,updateWorkOrderData){
          let index = state.popWorkOrderData.findIndex(item => item.pageUuId === updateWorkOrderData.oldUuId);
          if(index > -1){
            state.popWorkOrderData[index].pageUuId = updateWorkOrderData.newUuId;
          }
          index = state.workOrderReserve.findIndex(item => item.pageUuId === updateWorkOrderData.oldUuId);
          if(index > -1){
            state.workOrderReserve[index].pageUuId = updateWorkOrderData.newUuId;
            state.workOrderReserve[index].showPreInput = '';
          }
        },
        //去除指定工单数据
        cutWorkOrderData(state,breadList){
          let newList = [];
          let newListOne = [];
          state.workOrderCount = 0;
          for (let i = 0;i<breadList.length;i++){
            let orderReserveItem = state.workOrderReserve.find(item => {
              return item.pageUuId == breadList[i];
            });

            newList.push(orderReserveItem);

            let orderDataItem = state.popWorkOrderData.find(item => {
              return item.pageUuId == breadList[i];
            });
            newListOne.push(orderDataItem);
            state.workOrderCount++;
          }
          state.workOrderReserve = newList;
          state.popWorkOrderData = newListOne;
        },
        // push新消息
        // sessionMsg:::{“openId”:”ad2f3f23rf”,”agentNumber”:””,"headImg":"头像地址",”msgType”:”text”,”msgContent”:”你好，我想查快递”,”sessionId”:”1a2rf34sf5df”,”leftOrRight”:”left”,”tip”:””,”timestamp”:””,”msgSource”:”1”,"sessionId":"1"}
        pushMsg(state,sessionMsgObject){
            if(sessionMsgObject){
                
                let openId = sessionMsgObject.openId;
                let onlineInfo = state.onlineData.find(item => item.openId === openId);
                
                //{"sessionId":"","openId":"","headImg":"头像地址","lastTime":"最后时间","value":"姓名","unreadCnt":"未读消息数量","lastMsg":"最后一条消息","channelType":"渠道类型"}
                // 修改发送的左边信息，修改的字段有：最后时间，最后消息,未读消息
                let leftInfo = {
                    "sessionId": sessionMsgObject.sessionId,
                    "openId": sessionMsgObject.openId,
                    "lastTime": sessionMsgObject.createTime,
                    "lastMsg": sessionMsgObject.lastMsg ? sessionMsgObject.lastMsg : (sessionMsgObject.tip ? sessionMsgObject.tip : sessionMsgObject.content),
                    "channelType": sessionMsgObject.sessionChannel,
                    "msgType": sessionMsgObject.msgType,
                    "value": sessionMsgObject.value,
                    "unreadCnt":sessionMsgObject.tip ? (onlineInfo ? onlineInfo.leftInfo.unreadCnt : "0") : (onlineInfo ? onlineInfo.leftInfo.unreadCnt : "1"),  //tip提示不作为未读消息
                    "headImg": sessionMsgObject.headImg,
                    "wxName": sessionMsgObject.wxName,
                    "sessionType": sessionMsgObject.sessionType,
                    "msgSource": sessionMsgObject.msgSource,
                    "queueDuration": onlineInfo ? (onlineInfo.leftInfo.queueDuration ? onlineInfo.leftInfo.queueDuration : "0") : "0",
                    "queueTimeFun": onlineInfo ? (onlineInfo.leftInfo.queueTimeFun ? onlineInfo.leftInfo.queueTimeFun : '') : '',
                }

                if(sessionMsgObject.sessionType == "0"){  //排队中的才有定时，后期浏览中也会有定时
                    if(!leftInfo["queueDuration"]){
                        leftInfo["queueDuration"] = "0";
                    }
                    
                    if(leftInfo["queueTimeFun"]){
                        clearInterval(leftInfo["queueTimeFun"]);
                        leftInfo["queueTimeFun"] = setInterval(function(){
                            leftInfo["queueDuration"] = Number(leftInfo["queueDuration"])+1;
                        },1000);
                    }
                }else{
                    if(leftInfo["queueTimeFun"]){
                        clearInterval(leftInfo["queueTimeFun"]);
                    }
                }

                this.commit('pushOnlineLeftInfo',leftInfo);

                onlineInfo = state.onlineData.find(item => item.openId === openId);
                if(onlineInfo){
                    if(sessionMsgObject.type.indexOf("pushPublicChatMessage") === -1){
                        // this.commit('addUnreadCnt',1);
                        if(sessionMsgObject.sessionStatus != '2' && sessionMsgObject.sessionType != '0'){
                            onlineInfo.leftInfo.unreadCnt = Number(onlineInfo.leftInfo.unreadCnt) + 1;
                        }
                    }

                    onlineInfo.msgList.push(sessionMsgObject);
                    onlineInfo.wxName = sessionMsgObject.wxName;
                    onlineInfo.msgSource = sessionMsgObject.msgSource;

                }
            }
        },
        pushMsgList(state,sessionMsgList){
            if(sessionMsgList && sessionMsgList.length > 0){
                let openId = sessionMsgList[sessionMsgList.length-1].openId;
                let onlineInfo = null;
                if(openId){
                   onlineInfo = state.onlineData.find(item => item.openId === openId);
                }else{
                    onlineInfo = state.onlineData.find(item => item.sessionId === sessionMsgList[sessionMsgList.length-1].sessionId); ;
                }

                if(onlineInfo){
                    for(let i = 0; i < sessionMsgList.length; i++){
                        // 去重
                        let msg = onlineInfo.msgList.find(item => item.createTime === sessionMsgList[i].createTime);
                        if(!msg){
                            onlineInfo.msgList.unshift(sessionMsgList[i]);
                        }

                    }
                    if(sessionMsgList[sessionMsgList.length-1].msgSource){
                      onlineInfo.msgSource = sessionMsgList[sessionMsgList.length-1].msgSource;
                    }
                }
                // else{
                //     onlineInfo = {
                //         "openId": openId,
                //         "sessionChannel": sessionChannel,
                //         "sessionId": sessionId,
                //         "wxName": wxName,
                //         "name": name,
                //         "msgList": [],
                //         "leftInfo": {},
                //         "rightInfo":{},
                //     }
                //     state.onlineData.push(onlineInfo);
                // }

            }
        },
        // "leftInfo":{"sessionId":"","openId":"","headImg":"头像地址","lastTime":"最后时间","value":"姓名","unreadCnt":"未读消息数量","lastMsg":"最后一条消息","channelType":"渠道类型"}
        pushOnlineLeftInfo(state,leftInfoObject){
            let openId = leftInfoObject.openId;
            if(leftInfoObject.msgType == "text"){
                if(!leftInfoObject.lastMsg){
                    if(leftInfoObject.tip){
                        leftInfoObject["lastMsg"] = leftInfoObject.tip;
                    }else{
                        leftInfoObject["lastMsg"] = leftInfoObject.content;
                    }
                }
            }else if(leftInfoObject.msgType == "image"){
                leftInfoObject["lastMsg"] = "[图片]";
            }else if(leftInfoObject.msgType == "link"){
                leftInfoObject["lastMsg"] = "[链接]";
            }else if(leftInfoObject.msgType == "voice"){
                leftInfoObject["lastMsg"] = "[语音]";
            }else if(leftInfoObject.msgType == "video"){
                leftInfoObject["lastMsg"] = "[视频]";
            }else{
                leftInfoObject["lastMsg"] = "[文件]";
            }

            let onlineInfo = state.onlineData.find(item => item.openId === openId);  //查看是否有数据
            if(onlineInfo){
                if(leftInfoObject.channelType){
                    onlineInfo.sessionChannel = leftInfoObject.channelType;
                }
                if(leftInfoObject.wxName){
                    onlineInfo.wxName = leftInfoObject.wxName;
                }
                if(leftInfoObject.sessionId){
                    onlineInfo.sessionId = leftInfoObject.sessionId;
                }
                if(leftInfoObject.openId){
                    onlineInfo.openId = leftInfoObject.openId;
                }

                onlineInfo.msgSource = leftInfoObject.msgSource;

                if(!leftInfoObject.sessionType){
                    onlineInfo.sessionType = leftInfoObject.sessionType;
                }

                // leftInfoObject.unreadCnt = Number(onlineInfo.leftInfo.unreadCnt) + Number(leftInfoObject.unreadCnt);

                leftInfoObject.value = onlineInfo.name;
                onlineInfo.lastTime = leftInfoObject.lastTime ? leftInfoObject.lastTime : leftInfoObject.createTime;
                onlineInfo.leftInfo = leftInfoObject;

            }else{
                // 没有这个openId
               // [{"openId":"OPENID","sessionChannel":"渠道","wxName":"微信号","sessionId":"","name":"姓名"
        // "msgList":[{"createTime":"时间","openId":"","agentNumber":"","tip":"","content":"","contentRemark":"","headImg":"","name":"","msgType":""}],
        //"leftInfo":{"sessionId":"","openId":"","headImg":"头像地址","lastTime":"最后时间","value":"姓名","unreadCnt":"未读消息数量","lastMsg":"最后一条消息","channelType":"渠道类型"},
        //"rightInfo":{}]
                if(leftInfoObject.sessionType == "0"){  //排队中的才有定时，后期浏览中也会有定时
                    if(!leftInfoObject["queueDuration"]){
                        leftInfoObject["queueDuration"] = "0";
                    }
                    if(!leftInfoObject["queueTimeFun"]){
                        leftInfoObject["queueTimeFun"] = setInterval(function(){
                            leftInfoObject["queueDuration"] = Number(leftInfoObject["queueDuration"])+1;
                        },1000);
                    }
                }
                onlineInfo = {
                    "openId": leftInfoObject.openId,
                    "sessionChannel": leftInfoObject.channelType,
                    "sessionId": leftInfoObject.sessionId,
                    "wxName": leftInfoObject.wxName,
                    "msgSource": leftInfoObject.msgSource,
                    "msgList": [],
                    "leftInfo": leftInfoObject,
                    "rightInfo":{},
                    "value":leftInfoObject.value,
                    "name":leftInfoObject.value,
                    "customerType":'',
                    "sessionType": leftInfoObject.sessionType, // 会话类型 ，0默认排队1已分配2转接会话3多方会话
                    "lastTime":leftInfoObject.lastTime ? leftInfoObject.lastTime : leftInfoObject.createTime,  //最后一条消息的时间,用于排序
                    "lastMsg":leftInfoObject.lastMsg,  //最后一条消息
                }
                state.onlineData.push(onlineInfo);
            }

            // 排序,最后的消息在前面
            state.onlineData.sort(function(obj1, obj2){

                if(new Date(obj1.lastTime) > new Date(obj2.lastTime)){
                    return -1;
                }else{
                    return 1;
                }
            });
        },
        // 右侧客户资料
        pushOnlineRightInfo(state,rightInfoObject){
            let openId = rightInfoObject.openId;
            if(openId){
                let onlineInfo = state.onlineData.find(item => item.openId === openId);  //查看是否有数据
                if(onlineInfo){
                    //复制对象，避免多个客户使用同一个对象引用，修改其中一个，其他也会跟着改变
                    let objString = JSON.stringify(rightInfoObject);
                    let rightObj = JSON.parse(objString);

                    onlineInfo.rightInfo = rightObj;
                }
            }
        },
        // 在线客服工单数据
        pushOnlineWorkOrderInfo(state,workOrderObject){
          let openId = workOrderObject.openId;
          if(openId){
            let objectInfo = state.onlineData.find(item => item.openId === openId);  //查看是否有数据
            if(objectInfo){
              //复制对象，避免多个客户使用同一个对象引用，修改其中一个，其他也会跟着改变
              let objString = JSON.stringify(workOrderObject);
              let rightObj = JSON.parse(objString);

              objectInfo.workOrderInfo = rightObj;
            }
          }
        },
        delOnlineData(state,openId){
            let index = state.onlineData.findIndex(item => item.openId === openId);
            if(index > -1){
                let onlineInfo = state.onlineData.find(item => item.openId === openId);
                if(onlineInfo){
                    this.commit("delUnreadCnt", Number(onlineInfo.leftInfo.unreadCnt));
                }
                state.onlineData.splice(index,1);
            }
        },
        // 在线客服
        putMqClient(state,client) {
            state.globalMqClient = client;
          },
        //   未读消息增加
        addUnreadCnt(state, unreadCnt){
            state.globalUnreadMsgCnt.cnt = state.globalUnreadMsgCnt.cnt + unreadCnt;
        },
        //   未读消息减少
        delUnreadCnt(state, unreadCnt){
            state.globalUnreadMsgCnt.cnt = state.globalUnreadMsgCnt.cnt - unreadCnt;
            state.globalUnreadMsgCnt.cnt = state.globalUnreadMsgCnt.cnt < 0 ? 0 : state.globalUnreadMsgCnt.cnt;
        },
        pushNotice(state,obj){
            let noticeParam = {
                sessionChannel: 'Notice',
                lastMsg: '',
                name: obj.title,
                lastTime: obj.updateTime,
                topic: '',
                uuid: 'notice'+obj.id,
                msgFrom: '',
                unreadCnt : 1,
                noticeObj:JSON.stringify(obj),
            }
            state.globalNoticeMsgList.unshift(noticeParam);

            this.commit('addUnreadCnt',noticeParam.unreadCnt);
        },
        pushGlobalNoticeMsgList(state, obj){
            let msgFrom = obj.msgFrom;  //消息来源
            let noticeParam;
            let name; //姓名
            let uuid;  //唯一标识
            let unreadCnt = 1;
            if('chatOnLine' == msgFrom){
                name = obj.value;
                uuid = obj.openId;
                unreadCnt = obj.unreadCnt? Number(obj.unreadCnt) : unreadCnt;
            }else if('workOrder' == msgFrom){
                name = "工单#"+obj.msgMarket;
                uuid = obj.msgMarket;
            }
            noticeParam = state.globalNoticeMsgList.find(item => item.uuid === uuid);
            if(noticeParam){  //已经存在
                noticeParam.lastMsg = obj.content ? obj.content : obj.tip;
                noticeParam.name = name;
                noticeParam.lastTime = obj.createTime;
                noticeParam.unreadCnt = Number(noticeParam.unreadCnt ? noticeParam.unreadCnt : 0) + Number(unreadCnt);
                if('chatOnLine' == msgFrom){
                    this.commit('addUnreadCnt',1);
                }
            }else{
                noticeParam = {
                    sessionChannel: obj.sessionChannel,
                    lastMsg: obj.content ? obj.content : obj.tip,
                    name: name,
                    lastTime: obj.createTime,
                    topic: obj.orderTheme,
                    uuid: uuid,
                    msgFrom: obj.msgFrom,
                    unreadCnt : Number(unreadCnt),
                }
                state.globalNoticeMsgList.push(noticeParam);

                this.commit('addUnreadCnt',noticeParam.unreadCnt);

            }
        },
        removeNotice(state, uuid){
            let index = state.globalNoticeMsgList.findIndex(item => item.uuid === uuid);
            this.commit('delUnreadCnt',1);
            state.globalNoticeMsgList.splice(index,1);
        },
        removeGlobalNoticeMsgList(state, uuid){
            if('clearAll' === uuid){  //清除所有
                state.globalNoticeMsgList.length = 0;
                this.commit('delUnreadCnt',999);
            }else{
                let index = state.globalNoticeMsgList.findIndex(item => item.uuid === uuid);
                if(index > -1){
                    // 如果是在线客服，不删除未读，只有当点击时，才会减少未读。如果是工单，则点击删除未读
                    if(state.globalNoticeMsgList[index]['msgFrom'] == 'workOrder'){
                        this.commit('delUnreadCnt',state.globalNoticeMsgList[index].unreadCnt ? Number(state.globalNoticeMsgList[index].unreadCnt) : 0);
                    }
                    state.globalNoticeMsgList.splice(index,1);
                }
            }
        }
    },
    getters:{
        getReserve: (state) => (phone) => {
            return state.telephoneReserve.find(item => item.phoneUUid === phone);
        },
        getWorkOrderReserve: (state) => (code) => {
          return state.workOrderReserve.find(item => item.pageUuId === code);
        },
        getWorkOrderData: (state) => (pageUuId) => {
          return state.popWorkOrderData.find(item => item.pageUuId === pageUuId);
        },
        getCustomerData: (state) => (phoneUUid) => {
            return state.popCustomerData.find(item => item.phoneUUid === phoneUUid);
        },
        // return 所有会话
        getOnlineInfos: (state) => () => {
            return state.onlineData;
        },
        // 返回sessionId对应的客户消息
        getOnlineInfoByOpenId: (state) => (openId) => {
            return state.onlineData.find(item => item.openId === openId);
        },
        getTelephoneCount: (state) => () => {
            return state.telephoneCount;
        },
        getWorkOrderCount: (state) => () => {
            return state.workOrderCount;
        },
        getMqClient: (state) => () => {
            return state.globalMqClient;
        },
        getUnreadMsgCnt: (state) => () => {
            if(state.globalUnreadMsgCnt.cnt < 0){
                state.globalUnreadMsgCnt.cnt = 0;
            }
            return state.globalUnreadMsgCnt;
        },
        getGlobalNoticeMsgList:  (state) => () => {
            return state.globalNoticeMsgList;
        }
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js